export default __webpack_public_path__ + "static/gw2-banner-advanced-combat-a73b045179a62ffdb2a1f8c5dbe0392b.png";